import React from 'react'
import Link from 'gatsby-link'

class Lessons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <h1>Smidge</h1>
        <p>A collection of Lilo Rocks</p>
        <h1>Squish</h1>
        <p>Now knows what the monkeys says</p>
        <h1>Ba</h1>
        <p>Is the very best</p>
        <Link to="/">Go back to the homepage</Link>
      </div>

    );
  }
}

export default Lessons;


// WEBPACK FOOTER //
// ./src/pages/family/index.js